export default theme => ({
  tenKitesMenusEmbed: {
    position: "relative",
    marginBottom: 32,
  },
})
